import React from 'react';
import './LoadingSpinner.css';

/**
 * Spinner di caricamento riutilizzabile per le pagine pubbliche.
 * @param {string} [message] - Testo opzionale sotto lo spinner (es. "Caricamento medici...")
 */
const LoadingSpinner = ({ message }) => (
  <div className="vc-loading-spinner-wrap" role="status" aria-live="polite">
    <div className="vc-loading-spinner" aria-hidden="true" />
    {message && <p className="vc-loading-spinner-message">{message}</p>}
    <span className="visually-hidden">Caricamento in corso</span>
  </div>
);

export default LoadingSpinner;
